"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpanEl = exports.TextEl = exports.ColEl = exports.RowEl = exports.ImageEl = exports.SelectEl = exports.ColorEl = exports.IconEl = exports.NavEl = exports.FormEl = exports.LabelEl = exports.BrEl = exports.TextareaEl = exports.InputEl = exports.RadioEl = exports.CheckboxEl = exports.CustomCheckbox = exports.ButtonEl = exports.HeadingEl = exports.DivEl = void 0;
const UiBaseElement_1 = require("./UiBaseElement");
class DivEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('div'));
    }
}
exports.DivEl = DivEl;
class HeadingEl extends UiBaseElement_1.UIBaseElement {
    constructor(value) {
        super(document.createElement(value));
    }
}
exports.HeadingEl = HeadingEl;
class ButtonEl extends UiBaseElement_1.UIBaseElement {
    constructor(value = '', submitButton = false) {
        super(document.createElement('button'));
        this.domEl.className = 'button';
        this.domEl.textContent = value;
        if (submitButton) {
            this.domEl.type = 'submit';
        }
        else {
            this.domEl.type = 'button';
        }
    }
}
exports.ButtonEl = ButtonEl;
class CustomCheckbox {
    constructor(labelI18nKey, value) {
        this.label = document.createElement('label');
        this.checkbox = document.createElement('input');
        this.span = document.createElement('span');
        this.label.className = 'custom-checkbox';
        this.checkbox.type = 'checkbox';
        this.span.setAttribute('data-i18n-key', labelI18nKey);
        this.label.append(this.checkbox, this.span);
        this.setValue(value);
    }
    get container() {
        return this.label;
    }
    getValue() {
        return this.checkbox.checked;
    }
    setValue(value) {
        if (value !== undefined && value !== null) {
            this.checkbox.checked = value;
        }
    }
    setEvent(event, eventHandler) {
        this.checkbox.addEventListener(event, eventHandler, false);
    }
}
exports.CustomCheckbox = CustomCheckbox;
class CheckboxEl extends UiBaseElement_1.UIBaseElement {
    constructor(value) {
        super(document.createElement('input'));
        this.domEl.className = 'checkbox';
        this.domEl.type = 'checkbox';
        this.setValue(value);
    }
    getValue() { return this.domEl.checked; }
    setValue(value) {
        if (value !== undefined)
            this.domEl.checked = value;
        return this;
    }
}
exports.CheckboxEl = CheckboxEl;
class RadioEl extends UiBaseElement_1.UIBaseElement {
    constructor(value, name) {
        super(document.createElement('input'));
        this.domEl.className = 'radio';
        this.domEl.type = 'radio';
        this.setValue(value);
        this.setName(name);
    }
    getValue() { return this.domEl.value; }
    setValue(value) {
        if (value !== undefined)
            this.domEl.value = value;
        return this;
    }
    getName() { return this.domEl.name; }
    setName(name) {
        if (name !== undefined)
            this.domEl.name = name;
        return this;
    }
}
exports.RadioEl = RadioEl;
class InputEl extends UiBaseElement_1.UIBaseElement {
    constructor(value) {
        super(document.createElement('input'));
        this.domEl.className = 'input';
        this.domEl.setAttribute('autocomplete', 'off');
        this.setValue(value);
    }
    getValue() { return this.domEl.value; }
    setValue(value) {
        this.domEl.value = value;
        return this;
    }
}
exports.InputEl = InputEl;
class TextareaEl extends UiBaseElement_1.UIBaseElement {
    constructor(value) {
        super(document.createElement('textarea'));
        this.domEl.className = 'textarea';
        this.domEl.spellcheck = false;
        this.domEl.setAttribute('autocomplete', 'off');
        this.setPlaceholder(value);
        // this.setValue(value);
    }
    getValue() { return this.domEl.value; }
    setValue(value) {
        this.domEl.value = value;
        return this;
    }
    setPlaceholder(value) {
        this.domEl.placeholder = value;
        return this;
    }
}
exports.TextareaEl = TextareaEl;
class BrEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('br'));
        this.domEl.className = 'break';
    }
}
exports.BrEl = BrEl;
class LabelEl extends UiBaseElement_1.UIBaseElement {
    constructor(text, htmlFor = "") {
        super(document.createElement('label'));
        this.domEl.className = 'label';
        if (htmlFor) {
            this.domEl.htmlFor = htmlFor;
        }
        this.domEl.appendChild(document.createTextNode(text));
    }
}
exports.LabelEl = LabelEl;
class FormEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('form'));
    }
}
exports.FormEl = FormEl;
class NavEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('nav'));
    }
}
exports.NavEl = NavEl;
class IconEl extends UiBaseElement_1.UIBaseElement {
    constructor(iconName) {
        super(document.createElement('i'));
        this.setClass('ci ci-' + iconName);
    }
}
exports.IconEl = IconEl;
class ColorEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('input'));
        this.domEl.className = 'color-picker';
        this.domEl.type = 'color';
        this.domEl.setAttribute('autocomplete', 'off');
    }
    getValue() { return this.domEl.value; }
    setValue(value) {
        this.domEl.value = value;
        return this;
    }
    getHexValue() {
        return parseInt(this.domEl.value.substring(1), 16);
    }
    setHexValue(hex) {
        this.domEl.value = '#' + ('000000' + hex.toString(16)).slice(-6);
        return this;
    }
}
exports.ColorEl = ColorEl;
class SelectEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('select'));
        this.domEl.className = 'select';
        this.domEl.setAttribute('autocomplete', 'off');
    }
    setMultiple(flag) {
        this.domEl.multiple = flag;
        return this;
    }
    setOptions(options, selected) {
        // const selected = this.domEl.value;
        while (this.domEl.children.length > 0) {
            this.domEl.removeChild(this.domEl.firstChild);
        }
        for (const key in options) {
            const option = document.createElement('option');
            option.value = key;
            option.innerText = options[key];
            option.setAttribute('data-i18n-key', options[key]);
            if (key === selected)
                option.setAttribute('selected', '');
            this.domEl.appendChild(option);
        }
        this.domEl.value = selected;
        return this;
    }
    getValue() { return this.domEl.value; }
    setValue(value) {
        if (this.domEl.value !== value)
            this.domEl.value = value;
        return this;
    }
}
exports.SelectEl = SelectEl;
class ImageEl extends UiBaseElement_1.UIBaseElement {
    constructor(source) {
        super(document.createElement('img'));
        this.domEl.setAttribute('src', source);
    }
    getSource() { return this.domEl.getAttribute('src'); }
    setSource(value) {
        this.domEl.setAttribute('src', value);
        return this;
    }
}
exports.ImageEl = ImageEl;
class RowEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('div'));
        this.domEl.className = 'row';
    }
}
exports.RowEl = RowEl;
class ColEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('div'));
        this.domEl.className = 'col';
    }
}
exports.ColEl = ColEl;
class TextEl extends UiBaseElement_1.UIBaseElement {
    constructor(text) {
        super(document.createElement('span'));
        this.domEl.className = 'text';
        this.domEl.style.display = 'inline-block';
        this.setValue(text);
    }
    getValue() { return this.domEl.textContent; }
    setValue(value) {
        this.domEl.textContent = value;
        return this;
    }
}
exports.TextEl = TextEl;
class SpanEl extends UiBaseElement_1.UIBaseElement {
    constructor() {
        super(document.createElement('span'));
    }
}
exports.SpanEl = SpanEl;
